import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { homeSettingsApi } from "../services/homeSettings.service";

import {
    HOMESETTINGS_REQUEST,
    homeSettingsRequestSuccess,
    homeSettingsRequestFailure,
    homeSettingsRequest,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST,
    homeSettingsUpsertRequestFailure,
    homeSettingsUpsertRequestSuccess,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
    HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE
} from "../actions/homeSettings.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const homeSettingsRequestEpic = action$ =>
    action$
        .ofType(HOMESETTINGS_REQUEST)
        .mergeMap((action) =>
            homeSettingsApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(homeSettingsRequestSuccess(response.homeSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(homeSettingsRequestFailure(error.responseStatus.message))
                )
        );

export const homeSettingsUpsertRequestEpic = action$ =>
    action$
        .ofType(HOMESETTINGS_REQUEST_UPSERT_REQUEST)
        .mergeMap((action) =>
            homeSettingsApi
                .upsert(action.homeSettings)
                .mergeMap(response => {
                    return concat$(Observable.of(homeSettingsUpsertRequestSuccess(response.homeSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(homeSettingsUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const homeSettingsUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => homeSettingsRequest());

export const homeSettingsUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow("Home settings saved"));

export const homeSettingsUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
    action$
        .ofType(HOMESETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => siteDataRequest());

export const homeSettingsUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(HOMESETTINGS_REQUEST_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/homeSettings.epic.ts